import {createContext} from 'react';

import {TPredicateExpressionNode} from './types';

export interface IPredicateExpressionFormListContextArgs {
    childReportTemplateCode?: string | null;
    templateCode?: string | null;
    initialExpression: TPredicateExpressionNode | undefined;
}

export const PredicateExpressionFormListContext = createContext<IPredicateExpressionFormListContextArgs>({
    childReportTemplateCode: undefined,
    templateCode: undefined,
    initialExpression: undefined,
});
